import { fetchClient } from '@/util/fetchClient';

export async function sendReferralV2({ emails }: { emails: string[] }) {
  const { data } = await fetchClient.POST('/v2/referrals', {
    body: {
      emails,
    },
  });

  return data;
}
